<template>
  <!-- Words (content) saved as blocks, or a layout chosen in the studio. -->
  <SectionBand :heading="section.title" :variant="variant" :background="section.background" :width="width" label="Words">
    <BlockRenderer :blocks="section.blocks || []" :content="section.content || ''" :newsletter-link="newsletterLink" />
  </SectionBand>
</template>

<script setup>
import {computed} from "vue";
import SectionBand from "../shared/SectionBand.vue";
import BlockRenderer from "../blocks/BlockRenderer.vue";

const props = defineProps({
  section: {type: Object, required: true},
  variant: {type: [Number, String], default: 1},
  newsletterLink: {type: String, default: ""},
});
const width = computed(() => (["narrow", "wide"].includes(props.section.layout) ? props.section.layout : "normal"));
</script>
